import Clarity from '@microsoft/clarity'
import { reportScopedError } from 'shared-utils/error'

export default defineNuxtPlugin(() => {
  try {
    // Staging or production only
    if (
      import.meta.dev ||
      !import.meta.client
    ) {
      return
    }

    const config = useRuntimeConfig()
    const env = config.public

    if (!env.CLARITY_PROJECT_ID) {
      return
    }

    Clarity.init(
      String(env.CLARITY_PROJECT_ID)
    )

    // Clarity requires an explicit consent signal for EEA/UK/CH traffic since 2025-10-31,
    // otherwise it runs cookie-less (no session recording / visitor association).
    Clarity.consent()
  } catch (err) {
    const error = err as Error

    reportScopedError('plugins::clarity', 'Initialization failed', error)
  }
})
